import { Col, Row } from 'antd'
import Container from 'components/Container'
import { SkeletonFormItem, SkeletonItem } from 'components/Skeleton'
import { useTheme } from 'styled-components'

const TransactionFormSkeleton = () => {
	const theme = useTheme()

	return (
		<Container space="md" spaceDirection="vertical" margin={{ bottom: 'md' }}>
			<SkeletonFormItem />
			<Row gutter={[theme.margins.md, 0]}>
				<Col span={12}>
					<SkeletonFormItem />
				</Col>
				<Col span={12}>
					<SkeletonFormItem />
				</Col>
			</Row>
			<SkeletonFormItem />
			<SkeletonItem $size="large" />
		</Container>
	)
}

export default TransactionFormSkeleton
